import React from "react";
import Button from "../../components/button";
import { useNavigate } from "react-router-dom";
import { useSafeNavigate } from "../../components/unloadBlocker";
import PopUp, { closePopUp } from "../../components/popUp";



export default function PayOutSuccessPopUp() {
    const navigate = useSafeNavigate(useNavigate());
    return <PopUp onClose={() => {
            window.open("/dashboard/overview", "_self");

        
    }} title="Pay out request sent!">
        <p>Your pay out request was successfully sent.<br/>You will recieve your money in less then 7 days</p>
        <Button onClick={() => {
            window.open("/dashboard/overview", "_self");
            closePopUp();
        }}>Close</Button>
    </PopUp>
}